import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import {
  toggleLoading,
  getAppCurrentTheme,
  setAppError,
  setBranding,
} from '../../reducers/app'

export function NoAuth() {
  const dispatch = useDispatch()

  useEffect(() => {
    async function fetchInitialData() {
      try {
        dispatch(toggleLoading(true))
        const { payload } = await dispatch(getAppCurrentTheme())
        if (payload && payload.length > 0) {
          const theme = payload[0]
          const branding = {
            name: theme.brand_name,
            color: theme.color,
            logoUrl: theme.image_url,
            brandName: theme.brand_name,
            tabIconUrl: theme.tab_icon_url,
          }
          dispatch(setBranding(branding))
          localStorage.setItem('brand_name', branding.name)
          localStorage.setItem('brand_color', branding.color)
          localStorage.setItem('brand_logo', branding.logoUrl)
          localStorage.setItem('brand_name', branding.brandName)
          localStorage.setItem('tab_icon_url', branding.tabIconUrl)
        }
        dispatch(toggleLoading(false))
      } catch (error) {
        dispatch(setAppError({ error: true, message: 'Error on Authentication' }))
        dispatch(toggleLoading(false))
      }
    }
    fetchInitialData()
  }, [])

  return (
    <div>
      <Outlet />
    </div>
  )
}
export default NoAuth

NoAuth.propTypes = {
}

NoAuth.defaultProps = {
}
